import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarmUpQuestion } from '../../../types/lesson';
import { useLessonPersistedState } from '../useLessonPersistedState';
import TranslateToggle from './TranslateToggle';

interface Props {
    lessonId?: number;
    items: WarmUpQuestion[];
    teacherMode: boolean;
    sourceLanguage?: string;
    targetLanguage?: string;
}

const WarmUpSection: React.FC<Props> = ({ lessonId, items, teacherMode, sourceLanguage, targetLanguage }) => {
    const { t } = useTranslation('lesson');
    const [showTranslation, setShowTranslation] = useLessonPersistedState<Record<number, boolean>>(lessonId, 'warmup.showTranslation', {});
    const [fallback, setFallback] = useLessonPersistedState<Record<number, string>>(lessonId, 'warmup.fallbackTranslation', {});
    return (
        <div className="lesson-panel">
            <div>
                <div className="lesson-panel-kicker">{t('sections.warm_up.kicker', 'Speak first')}</div>
                <h2>{t('sections.warm_up.title', 'Where Would You Go?')}</h2>
                <p className="lesson-panel-desc">
                    {t('sections.warm_up.desc', "Discuss in pairs. Don't worry about using the exact expression yet — just talk.")}
                </p>
            </div>
            <div className="lesson-qgrid">
                {items.map((item, i) => (
                    <div className="lesson-qcard" key={i}>
                        <div className="lesson-qnum">{t('sections.question_n', 'Question {{n}}', { n: i + 1 })}</div>
                        <div className="lesson-word-target">
                            {item.question}
                            <TranslateToggle
                                text={item.question}
                                native={item.question_native}
                                fallback={fallback[i]}
                                onFallbackFetched={(text) => setFallback((prev) => ({ ...prev, [i]: text }))}
                                sourceLanguage={sourceLanguage}
                                targetLanguage={targetLanguage}
                                shown={!!showTranslation[i]}
                                onToggle={() => setShowTranslation((prev) => ({ ...prev, [i]: !prev[i] }))}
                            />
                        </div>
                        <div className="lesson-hint-box lesson-word-target">
                            <strong>{t('sections.warm_up.try_to_use', 'Try to use:')}</strong> {item.vocab_hints.join(', ')}
                        </div>
                    </div>
                ))}
            </div>
            {teacherMode && (
                <div className="lesson-teacher-note">
                    {t('sections.warm_up.teacher_note', 'Teacher note: this is diagnostic — listen for which patterns students already use naturally, without correcting yet.')}
                </div>
            )}
        </div>
    );
};

export default WarmUpSection;
